import type { CardProfileDto } from "../../types/CardProfileDto";
import type { CardProfileEntity } from "../../types/CardProfileEntity";

export const CardProfileDtoToEntity = ({ dynamicProperties, ...rest }: Readonly<CardProfileDto>): CardProfileEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            propertyId: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            mandatory: propValue.mandatory || false,
            value,
        };
    });

    return {
        ...rest,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
